(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oudie-pairs-well-with"] && !Shopify.designMode) return;
  try {
    class OudiePairsWellWith extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.target = this.closest('.shopify-section, dialog');
      this.target?.addEventListener('shopify:product:select', this.handleProductSelect);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.target?.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = async (event) => {
      const button = event.target.closest('[data-pairs-add]');
      if (!button || button.disabled) return;

      const status = this.querySelector('[data-pairs-status]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        if (!window.OudieCart?.addItems) throw new Error('Cart integration unavailable');
        await window.OudieCart.addItems({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          target: this,
          context: 'product',
          sourceId: this.dataset.blockId,
          open: true,
        });
        if (status) status.textContent = this.dataset.addedMessage;
      } catch (error) {
        if (status) status.textContent = this.dataset.errorMessage;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      event.promise?.then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId && !detail.newProduct) return;
        const next = detail.html.querySelector(`oudie-pairs-well-with[data-block-id="${this.dataset.blockId}"]`);
        const nextContent = next?.querySelector('[data-pairs-content]');
        const currentContent = this.querySelector('[data-pairs-content]');
        if (!next || !nextContent || !currentContent) return;
        currentContent.replaceWith(nextContent);
        this.dataset.empty = next.dataset.empty;
        if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
      }).catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[oudie-pairs] Variant update failed', error);
      });
    };
  }

  if (!customElements.get('oudie-pairs-well-with')) customElements.define('oudie-pairs-well-with', OudiePairsWellWith);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oudie-product-details"] && !Shopify.designMode) return;
  try {
    class OudieProductDetails extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.sequence = 0;
      this.target = this.closest('.shopify-section, dialog');
      this.target?.addEventListener('shopify:product:select', this.handleProductSelect, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.sequence++; this.controller?.abort(); }
    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const sequence = ++this.sequence;
      event.promise?.then(({ detail }) => {
        if (sequence !== this.sequence || !this.isConnected || !detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId && !detail.newProduct) return;
        const next = detail.html.querySelector(`oudie-product-details[data-block-id="${this.dataset.blockId}"]`);
        const nextContent = next?.querySelector('[data-product-details-content]');
        const current = this.querySelector('[data-product-details-content]');
        if (!nextContent || !current) return;
        current.querySelectorAll('details[data-detail-key]').forEach((row) => {
          const replacement = nextContent.querySelector(`[data-detail-key="${row.dataset.detailKey}"]`);
          if (replacement) replacement.open = row.open;
        });
        const focusedKey = document.activeElement?.closest('details[data-detail-key]')?.dataset.detailKey;
        current.replaceWith(nextContent);
        if (focusedKey) nextContent.querySelector(`[data-detail-key="${focusedKey}"] summary`)?.focus({ preventScroll: true });
        this.dataset.productId = next.dataset.productId;
      }).catch((error) => { if (error?.name !== 'AbortError') console.warn('[oudie-product-details] Variant update failed', error); });
    };
  }
  if (!customElements.get('oudie-product-details')) customElements.define('oudie-product-details', OudieProductDetails);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oudie-product-meta"] && !Shopify.designMode) return;
  try {
    class OudieProductMeta extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.target = this.closest('.shopify-section, dialog');
      this.target?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.target?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      event.promise?.then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId && !detail.newProduct) return;
        const next = detail.html.querySelector(`oudie-product-meta[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;
        const nextContent = next.querySelector('[data-product-meta-content]');
        const currentContent = this.querySelector('[data-product-meta-content]');
        if (!nextContent || !currentContent) return;
        currentContent.replaceWith(nextContent);
        this.dataset.empty = next.dataset.empty;
        if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
      }).catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[oudie-product-meta] Variant update failed', error);
      });
    };
  }

  if (!customElements.get('oudie-product-meta')) customElements.define('oudie-product-meta', OudieProductMeta);
  } catch(e) { console.error(e); }
})();

})();
